import http from '@/utils/http';

export interface IObj {
  [propName: string]: string | number | IObj[];
}
export interface IburiedPar {
  // [propName: string]: string | number | IObj;
  [propName: string]: any;
}

export default {
  // IP解析
  ipAnalysis() {
    return http.post('/common/ipAnalysis');
  },
};

const baseUrl = '/h5';

export const getWechatLinkByType = (par: IObj) =>
  http.post('/h5/userAgentLinkControl/getWechatLinkByType', par);
export const reportDetail = (par: IObj) => http.post('/h5/reportControl/reportDetail', par);

export const queryAgreementByScene = (par: IObj) =>
  http.post(`${baseUrl}/agreementControl/queryAgreementByScene`, par);
export const userSignAgreement = (par: IObj) =>
  http.post('/h5/agreementControl/userSignAgreement', par);

export const buriedOperation = (data: IburiedPar) => {
  return http.post('/h5/buriedPointControl/user/operation', data);
};
export const buriedOperationNoToken = (data: IburiedPar) => {
  return http.post('/h5/buriedPointControl/user/visit', data);
};
export const loginApi = (data: IburiedPar) => {
  return http.post('/h5/loginControl/oneClickLogin', data);
};

// 校验 linkId
export const userAgentLinkCheck = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/userAgentLinkCheck`, data);
};
// 根据域名获取appid
export const getWechatAppidByDomain = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/getAppidByDomain`, data);
};
//根据linkid获取域名与appid
export const getWechatAppidByLinkId = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/getLinkIdByDomain`, data);
};

//判断链接是否收费
export const getUserAgentByLinkId = (data: IburiedPar) => {
  return http.post(`${baseUrl}/user-agent/getUserAgentByLinkId`, data);
};
//获取清洁环境跳转链接
export const getVdiUrl = (data: IburiedPar) => {
  return http.post(`${baseUrl}/xg/getVdiUrl`, data);
};

// 获取验证码
export const getSmsCode = (data: IburiedPar) => {
  return http.post(`${baseUrl}/userControl/sendSmsCode`, data);
};

// 获取报告价格
export const getReportPrice = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/getReportQueryPrice`, data);
};

// 获取支持的支付方式
export const getPayMethods = () => {
  return http.post(`${baseUrl}/payControl/findSupportPayWay`);
};

// 调起原生支付宝支付
export const useAliWapPay = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/aliWapPay`, data);
};

// 调起通用支付
export const useCommonPay = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/pay`, data);
};

// 获取报告--在支付之前获取，拿到reportId
export const getReportId = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/getReportNow`, data);
};
//根据报告类型获取是否有历史类似订单
///xg/generatingOrder
export const generatingOrder = (data: IburiedPar) => {
  return http.post(`${baseUrl}/xg/generatingOrder`, data);
};

// 获取报告列表
export const getReportList = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/pageQuery`, data);
};
// 获取我的投诉列表
export const getMyComplaint = (data: IburiedPar) => {
  return http.post(`${baseUrl}/complaint/getUserComplaint`, data);
};

// 删除报告
export const deleteReport = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/deleteUserReportById`, data);
};

// 重新生成报告
export const reGenReport = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/createReportAgain`, data);
};

// 使用验证码登录
export const loginWithCode = (data: IburiedPar) => {
  return http.post(`${baseUrl}/loginControl/verificationCodeLogin`, data);
};

// 使用密码登陆
export const loginPassword = (data: any) => {
  return http.post(`${baseUrl}/loginControl/loginByPassword`, data);
};

// 忘记密码
export const loginForgetPassword = (data: any) => {
  return http.post(`${baseUrl}/loginControl/forgetPassword`, data);
};
// 修改密码
export const loginRevisePassword = (data: any) => {
  return http.post(`${baseUrl}/loginControl/revisePassword`, data);
};
// 申请提现
export const applyWithdrawal = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/withdrawalApply`, data);
};

// 获取提现个人账户信息
export const getAccountInfo = (data?: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/getWithdrawalAccount`, data);
};

// 获取系统参数
export const getSystemQuery = (data: IburiedPar) => {
  return http.post(`${baseUrl}/config/getSysParamsByKey`, data);
};

// 获取报告查询页的流水类型list
export const getSiteSearch = (data?: IburiedPar) => {
  return http.post(`${baseUrl}/xg/siteSearch`, data);
};
// 获取登录人姓名
export const getUserDetail = () => {
  return http.post(`${baseUrl}/userControl/userDetail`);
};
// 修改手机号
export const setUserPhone = (data: IburiedPar) => {
  return http.post(`${baseUrl}/userControl/bindPhone`, data);
};

// 获取支持的支付方式 -- 新
// linkId 在自查的时候没有
export type FindAdaSupportPayWayResItem = {
  code: number;
  paySubject: string;
  title: string;
  icon: string;
  appid?: string;
};
export type PayTypeItem = FindAdaSupportPayWayResItem & {
  curKey: string;
  /**
   * 1：微信
   * 2：支付宝
   * 3：上海汇付支付宝H5
   * 4：上海汇付微信H5
   * 6：联联微信支付
   * 7：联联支付宝
   * 8：微信 - 新 原生
   * 9：中金微信H5支付
   * 10：中金支付宝H5支付
   * 11：中金微信小程序支付
   * 12：中金微信JSAPI支付
   * 13：微信原生 JSAPI支付
   */
  payType: FindAdaSupportPayWayResItem['code'];
};
export const findAdaSupportPayWay = async (data: { linkId: string; payScene?: number }) => {
  try {
    const res = await http.post<FindAdaSupportPayWayResItem[]>(
      `${baseUrl}/payControl/findAdaSupportPayWay`,
      data
    );

    return (res || []).map((item) =>
      Object.assign(
        {
          curKey: `${item.paySubject}-${item.code}`,
          payType: item.code ? Number(item.code) : 1,
        },
        item
      )
    ) as PayTypeItem[];
  } catch {
    /** */
  }
};

// 查询支付结果
export const checkPayResult = (data?: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/queryOrderStatus`, data);
};

// 创建支付订单
export const createPayOrder = (data?: IburiedPar) => {
  return http.post<{
    orderNo: string;
    orderId: number;
  }>(`${baseUrl}/payControl/createOrder`, data);
};

// 获取报告状态
export const getReportDetailBySerial = (data: { serialNumber: string }) => {
  return http.post(`${baseUrl}/reportControl/getReportDetailBySerial`, data);
};

//根据code获取openId
export const getOpenidByCode = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/getOpenidByCode`, data);
};
//根据报告id获取用户信息
export const getUserInfoByReportId = (data: IburiedPar) => {
  return http.post(`${baseUrl}/payControl/getReportUserDetails`, data);
};




// 拉起支付
export const launchPayHandle = (data: {
  reportId: string;
  orderId: number | string;
  payType: number;
  paySubject: string;
  environmentType: 1 | 2 | 3; // 支付环境 1：V1 2：V2 3:V3
  openId?: any;
}) => {
  return http.post(`${baseUrl}/payControl/payment`, data);
};
// 短链接参数
export const shortLinkData = (data: { encryptedData: any }) => {
  return http.post(`${baseUrl}/shortLinkController/getShortLinkParams`, data);
};

// 获取最近一次支付成功的订单
export const getLatestOrder = (data: IburiedPar) => {
  return http.post(`${baseUrl}/order/getLatestOrder`, data);
};

// 上传文件
export const uploadFile = (data: IburiedPar) => {
  return http.upload(`${baseUrl}/uploadControl/uploadToOss`, data);
};

// 根据 code 查询字典的数据
export const getDicValByCode = (data: IburiedPar) => {
  return http.post(`${baseUrl}/common/dataList`, data);
};

// 提交反馈
export const uploadFeedback = (data: IburiedPar) => {
  return http.post(`${baseUrl}/feedback/addFeedback`, data);
};

// 回复反馈
export const replyFeedback = (data: IburiedPar) => {
  return http.post(`${baseUrl}/feedback/reply`, data);
};

// 获取链接价格
export const getUserLinkPrice = (data: {
  linkType: number;
  reportType: number;
  userDefinedReportType: string; // 用户自定义报告的标识
}) => {
  return http.post(`${baseUrl}/userAgentLinkControl/getUserLinkPrice`, data);
};

// 账户收支总览
export const accountDetailsV2Overview = () =>
  http.post<{
    divAccountSum: number; // 已分账金额分 (累计提现)
    canDivAccountSum: number; // 待分账金额 分
    commissionIncomeTotal: number; // 累计佣金收益(单位: 分)
    commissionDeductTotal: number; // 累计佣金扣除(单位: 分)
  }>(`${baseUrl}/userControl/accountDetailsV2Overview`);

// 生成链接
export const createLink = (data: IburiedPar) => {
  return http.post(`${baseUrl}/userAgentLinkControl/createLink`, data);
};

// 生成一码多用的链接
export const createMultiSelectionLink = (data: IburiedPar) =>
  http.post(`${baseUrl}/userAgentLinkControl/createMultiSelectionLink`, data);

// 获取银行卡
export const bankCardDetail = () => {
  return http.post(`${baseUrl}/withdrawal/bankCardDetail`);
};

// 绑定银行卡
export const bindBankCard = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/bindBankCard`, data);
};

// 解绑银行卡
export const unBindBankCard = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/unBindBankCard`, data);
};

/**
 * 根据类型获取媒体列表
 *
 * { name: 'LOGO', value: 1 },
 * { name: '个人', value: 2 },
 * { name: '婚恋', value: 3 },
 * { name: '家政', value: 4 },
 * { name: '租赁', value: 5 },
 * { name: '企业', value: 6 },
 * { name: '首页底部占位', value: 7 },
 * { name: '推广顶部占位', value: 8 },
 * { name: '默认头像', value: 9 },
 * { name: '邀请海报', value: 10 },
 * { name: '报告海报-个人Pro', value: 11 },
 * { name: '报告海报-婚恋', value: 12 },
 * { name: '报告海报-家政', value: 13 },
 * { name: '报告海报-企业 ', value: 14 },
 * { name: '报告海报-租赁 ', value: 15 },
 * { name: '报告海报-多类推广', value: 16 },
 * { name: '物料申请占位', value: 17 },
 * { name: '首页 banner', value: 18 },
 * { name: '个人推广展业', value: 19 },
 * { name: '邀请下级', value: 20 },
 * { name: '免费税票', value: 21 },
 * { name: '报告海报-税票', value: 22 },
 * { name: '报告海报-个人', value: 23 },
 * { name: '报告海报-司法', value: 24 },
 * { name: '入口-自定义报告', value: 25 },
 * { name: '物料海报', value: 26 },
 */
export const getMediaList = (data: IburiedPar) => {
  return http.post(`${baseUrl}/media/list`, data);
};

// 业绩概览 个人推广数据
export const getPromotionData = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/promotionData`, data);
};

// 业绩概览 个人推广数据 分页
export const getPromotionDataPage = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/promotionDataPage`, data);
};

// 业绩概览 个人推广数据 筛选总计
export const getPromotionDataCount = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/promotionDataCount`, data);
};

// 业绩概览 拓展推广数据
export const getExpandPromotionData = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/expandPromotionData`, data);
};

// 业绩概览 拓展推广数据 分页
export const getExpandPromotionDataPage = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/expandPromotionDataPage`, data);
};

// 业绩概览 拓展推广数据 筛选总计
export const getExpandPromotionDataCount = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/expandPromotionDataCount`, data);
};

// 业绩概览 拓展推广人数 分页
export const getExpandZTAgentPage = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/expandZTAgentPage`, data);
};

// 业绩概览 拓展推广人数 统计
export const getExpandZTAgentCount = (data: IburiedPar) => {
  return http.post(`${baseUrl}/statistics/expandZTAgentCount`, data);
};

// 累计佣金收益列表
export const getCumulativeCommissionList = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/cumulativeCommissionList`, data);
};

// 累计佣金收益列表筛选时间总计
export const getCumulativeCommissionCount = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/cumulativeCommissionCount`, data);
};

// 获取累计提现统计
export const getWithdrawalCount = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/cumulativeWithdrawalCount`, data);
};

// 获取累计提现列表
export const getWithdrawalRecord = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/cumulativeWithdrawalList`, data);
};

// 获取累计提现统计
export const getCommissionDeductV2Count = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/commissionDeductV2Count`, data);
};

// 累计佣金扣除列表V2
export const getCommissionDeductV2List = (data: IburiedPar) => {
  return http.post(`${baseUrl}/withdrawal/commissionDeductV2List`, data);
};

// 推广报告列表
export const getDirectReportPage = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/directReportPage`, data);
};

// 微信登录
export const loginByWechat = (data: IburiedPar) => {
  return http.post(`${baseUrl}/loginControl/loginByWechat`, data);
};

// 反馈列表
export const feedbackList = (data: IburiedPar) => {
  return http.post(`${baseUrl}/feedback/page`, data);
};

// 反馈详情
export const feedbackDetail = (data: IburiedPar) => {
  return http.post(`${baseUrl}/feedback/detail`, data);
};

// 反馈已读
export const readFeedback = (data: IburiedPar) => {
  return http.post(`${baseUrl}/feedback/read`, data);
};

// 查询是否有未读消息
export const getUnreadFb = () => {
  return http.post(`${baseUrl}/feedback/queryUnread`);
};

// 获取报告查询项
export const queryReportContentItems = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/queryReportContentItems`, data);
};
// 获取自定义报告内容项
export const getCustomizeItems = (data: IburiedPar) => {
  return http.post(`${baseUrl}/user-defined-report/getReportItems`, data);
};
// 登出
export const fetchLoginOut = () => {
  return http.post(`${baseUrl}/loginControl/loginOut`);
};

// 上传文件到汇付
export const uploadToHf = (data: IburiedPar) => {
  return http.upload(`${baseUrl}/uploadControl/uploadToHf`, data);
};

// 创建对公账户
export const bindAdaCompany = (data: IburiedPar) => {
  return http.post(`${baseUrl}/ada/bindAdaCompany`, data);
};

// 查询汇付支持的银行
export const queryHFBankList = (data: IburiedPar) => {
  return http.post(`${baseUrl}/ada/queryHFBankList`, data);
};

export const queryAdaCity = (data: IburiedPar) => {
  return http.post(`${baseUrl}/ada/queryAdaCity`, data);
};

// 生成pdf
export const createReportPdf = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/createReportPdf`, data);
};

// 下载pdf
export const reportDownload = (data: IburiedPar) => {
  return http.post(`${baseUrl}/reportControl/reportDownload`, data, { responseType: 'blob' });
};

// 我的团队
export const getMyTeam = (data: IburiedPar) =>
  http.post(`${baseUrl}/statistics/myTeamStatistics`, data);

// 获取所有报告类型价格
// export type GetMulSelLinkPriceReturnItem = {
//   basePrice: number; //	底价(单位：元)
//   maxPrice: number; //	最大价格(单位：元)
//   minPrice: number; //	最小价格(单位：元)
//   rakePrice: number; //	抽佣起始价(单位：元)
//   floatQueryPrice: number; //	浮动查询价(单位：元)
//   floatCoastPrice: number; //	浮动成本价(单位：元)
//   reportType: number; //	报告类型
// };
export const getMultiSelectionLinkPrice = (data: {
  linkType: 1 | 2; // 链接类型 1：代理商直推 2：邀请好友
  reportTypeList: number[]; // 系统报告类型
  userDefinedReportTypeList?: string[]; // 自定义报告类型
}) => http.post(`${baseUrl}/userAgentLinkControl/getMultiSelectionLinkPrice`, data);

// 查询当天注册为代理人的用户
export const getCurrentDayUserAgentInfo = () =>
  http.post<{ name: string; phone: string }[]>(`${baseUrl}/user-agent/getCurrentDayUserAgentInfo`);

// 当天查询报告
export const getIndexQueryReportList = () =>
  http.post<{ name: string; phone: string }[]>(`${baseUrl}/user-agent/getIndexQueryReportList`);

// 我的团队
export const myAssets = () => http.post(`${baseUrl}/statistics/getIncome`);

// 文章列表
export const getArticle = (data: {
  currentPageNum: number;
  pageSize: number;
  query?: {
    title?: string; //
    id?: string | number;
  };
}) => http.post(`${baseUrl}/article/page`, data);

export const editPageView = (data: { id: string | number }) =>
  http.post(`${baseUrl}/article/updatePv`, data);

// 动态路由文件
export const getTextUrl = (data: { fileName: string }) =>
  http.post(`${baseUrl}/domain/b/wachtxt`, data);
